import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

function redirectVendorHome(auth: AuthService, router: Router, url: string) {
  const user = auth.user();
  if (url === '/' && user?.role === 'vendor' && user.vendor_id) {
    return router.parseUrl(`/vendors/${user.vendor_id}`);
  }
  return true;
}

export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return redirectVendorHome(auth, router, state.url);
  }

  const token = localStorage.getItem('access_token');
  if (!token) {
    return router.parseUrl('/login');
  }

  return auth.hydrate().then(() => (auth.isAuthenticated() ? redirectVendorHome(auth, router, state.url) : router.parseUrl('/login')));
};
